<div *ngIf="!isLoadingUserInfo" class="mp-main-container" style="height: 100%">
    <mat-card class="mp-profile-view-card">
        <app-profile-info-general
            [name]="userProfile.displayName"
            [email]="userProfile.email"
            [userID]="userProfile.uid"
            [memberSince]="userProfile.createdOn"
            [timeZone]="userProfile.timeZone"
            [profileUrl]="userProfile.profileUrl"
            [photo]="userProfile.photoUrl"
            [isFmAdmin]="isFmAdmin"
            [numCompletedSessions]="userProfile.compSessions"
            [uid]="userProfile.uid"
            [status]="userProfile.status"
            [saved]="userProfile.saved"
            [snoozeStatus]="userProfile.snoozeStatus"
            [snoozeExpiresAt]="userProfile.snoozeExpiresAt"
            [sharedAvailability]="userProfile.sharedAvailability"
            [valid]="userProfile.valid"
            [lastMetSessionTime]="userProfile.lastSessionTime"
            [sharedSessions]="userProfile.sharedSessions"
            [profileTags]="userProfile.profileTags"
            (onUserAction)="handleUserAction($event)">
        </app-profile-info-general>

        <mat-card-content *ngIf="userProfile.valid" class="mp-card-content">
            <div *ngIf="isFmAdmin" class="customHr">.</div>
            <app-profile-info-status
                *ngIf="isFmAdmin"
                [isSuspended]="userProfile.suspended"
                [isVerified]="userProfile.isVerified"
                [planAccess]="userProfile.planInfo.productAccess"
                [canCancel]="userProfile.planInfo.canCancel"
                [isCanceled]="userProfile.planInfo.isCanceled"
                [currentEmailAddress]="userProfile.email"
                (onSuspend)="suspendUser()"
                (onRestore)="restoreUser()"
                (onVerifyUser)="verifyUser($event)"
                (onCancelSub)="cancelSubscription()"
                (onUpdateEmailAddress)="updateEmailAddress($event)">
            </app-profile-info-status>

            <app-profile-info-streaks
                *ngIf="isFmAdmin"
                class="w-full"
                [attendanceScore]="userProfile.attRate"
                [compSessions]="userProfile.compSessions"
                [weeklyStreak]="userProfile.weeklyStreak"
                [monthlyStreak]="userProfile.monthlyStreak">
            </app-profile-info-streaks>

            <div *ngIf="userProfile.group.length > 0" class="customHr">.</div>

            <app-profile-info-groups
                [groupInfo]="userProfile.group"
                [timeZone]="userProfile.timeZone">
            </app-profile-info-groups>

            <div class="customHr">.</div>
            <app-profile-info-qanda [qandaInfo]="userProfile.qanda"> </app-profile-info-qanda>

            <div *ngIf="isFmAdmin && userProfile.meetings.length != 0" class="customHr">.</div>
            <app-profile-info-sessions
                *ngIf="isFmAdmin"
                [meetings]="userProfile.meetings"></app-profile-info-sessions>
        </mat-card-content>
    </mat-card>
</div>
